<div class="modal-body ring-central-modal-body" data-automation="ring-central-polling-modal">
  <h4 class="ring-central-modal-header">
    <i [class]="'text-warning me-1 ' + ziroIcons.SAVING"></i>
    {{ 'tkey;migrations.create.ring_central.polling_modal.title' | translate }}
  </h4>
  <p>{{ 'tkey;migrations.create.ring_central.polling_modal.message' | translate }}</p>
  <div>
    <ul
      class="ring-central-data-list"
      [innerHTML]="'tkey;migrations.create.ring_central.polling_modal.list_1' | escapeHtml"
    ></ul>
    <ul
      class="ring-central-data-list"
      [innerHTML]="'tkey;migrations.create.ring_central.polling_modal.list_2' | escapeHtml"
    ></ul>
  </div>
  <hr />
  <div
    class="text-muted small"
    [innerHTML]="
      'tkey;migrations.create.ring_central.polling_modal.helptext' | escapeHtml: { tenantId: modalProperties.tenantId }
    "
  ></div>
</div>
<div class="modal-footer ring-central-modal-footer">
  <div class="text-end m-0">
    <ziro-button
      [type]="ButtonTypes.BUTTON"
      [label]="'tkey;migrations.create.ring_central.polling_modal.button'"
      [icon]=""
      [dataAutomation]="'ring-central-polling-modal-accept-button'"
      (clicked)="closeModal()"
    ></ziro-button>
  </div>
</div>
